import styled from "styled-components";

export const Image = styled.img`
  width: 248px;
  margin-left: -10px;
`;
